import { render } from "./ViewrMobile.vue?vue&type=template&id=d1c691d6&class=teste"
import script from "./ViewrMobile.vue?vue&type=script&lang=js"
export * from "./ViewrMobile.vue?vue&type=script&lang=js"

import "./ViewrMobile.vue?vue&type=style&index=0&id=d1c691d6&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__